function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { checkIsTizenVersion, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { sdkLogger } from '../../logger';
import { AudioFormat } from '../../core/player/audio-format';
import { DEFAULT_VIDEO_FORMAT, getVideoFormatFromResolution, VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { probeSupportedAudioCodecs, isAudioCodecSupported, isVideoCodecSupported } from '../../utils/probe-utils';
import { UhdHdrCodec, AudioCodecType } from '../../utils/probe-utils.enums';
function getMaxFrameRate() {
    return Infinity;
}
export function isFullHDmodel(context) {
    var _context_webapis_productinfo, _context_webapis;
    var isFHD = (_context_webapis = context.webapis) === null || _context_webapis === void 0 ? void 0 : (_context_webapis_productinfo = _context_webapis.productinfo) === null || _context_webapis_productinfo === void 0 ? void 0 : _context_webapis_productinfo.getModelCode().toLocaleUpperCase().split('_').includes('FHD');
    return isFHD !== false;
}
function getMaxVideoFormat() {
    return _getMaxVideoFormat.apply(this, arguments);
}
function _getMaxVideoFormat() {
    _getMaxVideoFormat = _async_to_generator(function() {
        var UHDsupported, logger, is4kCodecSupported, _self_webapis_systeminfo, _self_webapis, _self_webapis_systeminfo1, _self_webapis1, _ref, height, width, _self_webapis_productinfo_isUdPanelSupported, _self_webapis_productinfo, _self_webapis2;
        return _ts_generator(this, function(_state) {
            UHDsupported = false;
            logger = sdkLogger.withContext('TIZEN_CAPS');
            if (isFullHDmodel(self)) {
                logger.verbose('Detected FHD => Returning HD');
                return [
                    2,
                    DEFAULT_VIDEO_FORMAT
                ];
            }
            is4kCodecSupported = isVideoCodecSupported(UhdHdrCodec.Uhd);
            if (is4kCodecSupported) {
                ;
                logger.verbose('4K codec support detected');
                // getMaxVideoResolution only exists for Tizen 6+. For Tizen < 6, just check isUdPanelSupported
                _ref = ((_self_webapis = self.webapis) === null || _self_webapis === void 0 ? void 0 : (_self_webapis_systeminfo = _self_webapis.systeminfo) === null || _self_webapis_systeminfo === void 0 ? void 0 : _self_webapis_systeminfo.getMaxVideoResolution) ? self.webapis.systeminfo.getMaxVideoResolution() : {
                    height: undefined,
                    width: undefined
                }, height = _ref.height, width = _ref.width;
                logger.verbose("Detected height/width: ".concat(height, "/").concat(width));
                if (!((_self_webapis1 = self.webapis) === null || _self_webapis1 === void 0 ? void 0 : (_self_webapis_systeminfo1 = _self_webapis1.systeminfo) === null || _self_webapis_systeminfo1 === void 0 ? void 0 : _self_webapis_systeminfo1.getMaxVideoResolution) || height && width && getVideoFormatFromResolution({
                    width: width,
                    height: height
                }) === VideoFormat.UHD) {
                    ;
                    UHDsupported = (_self_webapis2 = self.webapis) === null || _self_webapis2 === void 0 ? void 0 : (_self_webapis_productinfo = _self_webapis2.productinfo) === null || _self_webapis_productinfo === void 0 ? void 0 : (_self_webapis_productinfo_isUdPanelSupported = _self_webapis_productinfo.isUdPanelSupported) === null || _self_webapis_productinfo_isUdPanelSupported === void 0 ? void 0 : _self_webapis_productinfo_isUdPanelSupported.call(_self_webapis_productinfo);
                    logger.verbose("isUdPanelSupported: ".concat(UHDsupported));
                }
            } else {
                logger.verbose('4K codec support not detected');
            }
            if (is4kCodecSupported && UHDsupported) {
                logger.verbose("UHD Support Detected!");
                return [
                    2,
                    VideoFormat.UHD
                ];
            } else {
                logger.verbose('HD Support ONLY!');
                return [
                    2,
                    DEFAULT_VIDEO_FORMAT
                ];
            }
            return [
                2
            ];
        });
    });
    return _getMaxVideoFormat.apply(this, arguments);
}
function getSupportedColourSpaces() {
    return _getSupportedColourSpaces.apply(this, arguments);
}
function _getSupportedColourSpaces() {
    _getSupportedColourSpaces = _async_to_generator(function() {
        var _self_webapis_avinfo_isHdrTvSupport, _self_webapis_avinfo, colourSpaces;
        return _ts_generator(this, function(_state) {
            colourSpaces = [
                VideoColourSpace.SDR
            ];
            if ((_self_webapis_avinfo = self.webapis.avinfo) === null || _self_webapis_avinfo === void 0 ? void 0 : (_self_webapis_avinfo_isHdrTvSupport = _self_webapis_avinfo.isHdrTvSupport) === null || _self_webapis_avinfo_isHdrTvSupport === void 0 ? void 0 : _self_webapis_avinfo_isHdrTvSupport.call(_self_webapis_avinfo)) {
                if (isVideoCodecSupported(UhdHdrCodec.Hdr10)) {
                    colourSpaces.push(VideoColourSpace.HDR10);
                }
                if (isVideoCodecSupported(UhdHdrCodec.HdrHlg)) {
                    colourSpaces.push(VideoColourSpace.HDRHLG);
                }
            }
            // Presently, no Samsung TVs support Dolby Vision, so no need to check for it.
            return [
                2,
                colourSpaces
            ];
        });
    });
    return _getSupportedColourSpaces.apply(this, arguments);
}
function getSupportedAudioFormats() {
    var audioFormats = [
        AudioFormat.STEREO,
        AudioFormat.SURROUND_5_1
    ];
    // All Samsungs 2015+ support ac-3
    if (isAudioCodecSupported(AudioCodecType.DolbyDigitalPlus)) {
        audioFormats.push(AudioFormat.SURROUND_7_1, AudioFormat.ATMOS);
    }
    return audioFormats;
}
function getSupportedAudioCodecs() {
    return probeSupportedAudioCodecs();
}
function getPreloadSupport() {
    return {
        preconstructItems: true,
        preloadItems: false,
        hasPrefetchSupport: false
    };
}
function getCompatibleStreamPropertyGroups() {
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function _getCompatibleStreamPropertyGroups() {
    _getCompatibleStreamPropertyGroups = _async_to_generator(function() {
        var _ref, maxFrameRate, maxVideoFormat, supportedColourSpaces;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getMaxFrameRate(),
                            getMaxVideoFormat(),
                            getSupportedColourSpaces()
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), maxFrameRate = _ref[0], maxVideoFormat = _ref[1], supportedColourSpaces = _ref[2];
                    return [
                        2,
                        [
                            {
                                maxFrameRate: maxFrameRate,
                                maxVideoFormat: maxVideoFormat,
                                supportedColourSpaces: supportedColourSpaces
                            }
                        ]
                    ];
            }
        });
    });
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function getCodecSwitchingSupport(device) {
    return !(checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-2.4']) || checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-2.3']));
}
function shouldUseXhr(device) {
    return checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-2.3']) || checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-2.4']) || checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-3']) || checkIsTizenVersion(device.deviceInfo, TizenVersion['Tizen-4']);
}
function getHdcpCompliance() {
    return _getHdcpCompliance.apply(this, arguments);
}
function _getHdcpCompliance() {
    _getHdcpCompliance = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                true
            ];
        });
    });
    return _getHdcpCompliance.apply(this, arguments);
}
export var mseTizenCapabilities = {
    getCompatibleStreamPropertyGroups: getCompatibleStreamPropertyGroups,
    getSupportedAudioFormats: getSupportedAudioFormats,
    getSupportedAudioCodecs: getSupportedAudioCodecs,
    getPreloadSupport: getPreloadSupport,
    getCodecSwitchingSupport: getCodecSwitchingSupport,
    shouldUseXhr: shouldUseXhr,
    getHdcpCompliance: getHdcpCompliance
};

//# sourceMappingURL=mse-capabilities.js.map